import React, { useState } from "react";

import { Tabs, Tab, Box, useMediaQuery, useTheme } from "@mui/material";
// import { getUser } from '../utils/common'
import DeviceDataList from "./deviceDataList";

const steps = ["All Devices", "Pending Devices"];

/**
 * Represents the Add Details component.
 *
 * This component allows users to add different kinds of details through multiple tabs based on user type.
 *
 * @returns {React.FC} The Add Details component.
 */
export const Devices: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {/* <CardHeader title="ClickHouse Instances"
        subheader="Add or remove clickHouse Instances details."
        avatar={
          <Avatar><Key /></Avatar>
        }
      /> */}
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs for env variables"
          >
            {steps.map((ele: string, index: number) => {
              return (
                <Tab
                  sx={{ fontSize: isMobile || isTablet ? "10px" : undefined }}
                  label={ele}
                  id={`${ele}-${index}`}
                  key={`env-tabs-${index}`}
                />
              );
            })}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <DeviceDataList isWithOrg={true} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DeviceDataList isWithOrg={false} />
        </TabPanel>
      </Box>
    </>
  );
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-env-${index}`}
      aria-labelledby={`simple-tab-env-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
